import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';

import { useNetworkStatus } from 'hooks';

import dictionary from 'config/dictionary';
import styles from './offline-banner.module.scss';

const OfflineBanner = props => {
  const { className } = props;

  const isOnline = useNetworkStatus();

  return (
    <CSSTransition
      in={!isOnline}
      timeout={200}
      appear={true}
      classNames={{
        enter: styles.offlineEnter,
        enterActive: styles.offlineEnterActive,
        enterDone: styles.offlineEnterDone,
        exit: styles.offlineExit,
        exitActive: styles.offlineExitActive,
        exitDone: styles.offlineExitDone
      }}
    >
      <div className={classnames(className, styles.offline)}>
        {dictionary.offlineBanner.offline}
      </div>
    </CSSTransition>
  );
};

OfflineBanner.propTypes = {
  className: PropTypes.string
};

export default OfflineBanner;
